<!-- 草稿箱新建记录 -->
<template>
  <div
    style="
      background-color: #f0f2f5;
      margin: -20px -30px -30px -20px;
      padding: 20px 30px 30px 20px;
      min-height: calc(100vh - 65px);
    "
  >
    <!-- 同步本地图文模板 复制草稿到其他公众号 切换 -->
    <div style="display: flex; margin-bottom: 15px">
      <div
        v-for="item in tabData"
        :key="item.key"
        class="tab-box"
        :class="[item.status ? 'tab-box-true' : '']"
        @click="tabChagen(item)"
      >
        {{ item.label }}
      </div>
    </div>

    <div v-show="show_page_type == 1">
      <!-- 标题 -->
      <div style="background-color: #fff; padding: 20px; margin-bottom: 15px">
        <!-- <div class="page-title">草稿箱新建记录</div> -->

        <div
          style="
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin: 10px 0 0;
          "
        >
          <div class="screen-box">
            <div class="screen-label">同步时间范围</div>
            <a-range-picker
              style="width: 260px"
              @change="onChangeDate"
              :allowClear="false"
              :locale="locale"
              :value="[
                this.moment(startTime, dateFormat),
                this.moment(endTime, dateFormat),
              ]"
            />
          </div>

          <div class="screen-box">
            <div class="screen-label">模板名称</div>
            <a-input
              v-model="r_name"
              allowClear
              placeholder="请输入"
              style="width: 200px"
            />
          </div>

          <div class="screen-box">
            <div class="screen-label">书城</div>
            <a-select
              show-search
              allowClear
              style="width: 180px"
              placeholder="请选择书城"
              @change="handleChangeB"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
            >
              <a-select-option
                v-for="(item, index) in bookList"
                :key="index"
                :value="item.key"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>

          <div class="screen-box">
            <div class="screen-label">公众号</div>
            <a-select
              show-search
              allowClear
              notFoundContent="← 请先选择: 书城"
              style="width: 180px"
              placeholder="请选择公众号"
              @change="handleChangeA"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
            >
              <a-select-option
                v-for="(value, key) in gzhSelect"
                :key="key"
                :value="key"
              >
                {{ value }}
              </a-select-option>
            </a-select>
          </div>

          <div class="screen-box">
            <div class="screen-label">状态</div>
            <a-select
              show-search
              allowClear
              style="width: 160px"
              placeholder="请选择状态"
              @change="handleChangeD"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
            >
              <a-select-option :value="0">待进行</a-select-option>
              <a-select-option :value="1">成功</a-select-option>
              <a-select-option :value="2">失败</a-select-option>
              <a-select-option :value="3">进行中</a-select-option>
            </a-select>
          </div>
          <div class="screen-box">
            <div class="screen-label">类型</div>
            <a-select
              show-search
              allowClear
              style="width: 160px"
              placeholder="请选择类型"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
              v-model="r_type"
            >
              <!-- 1= H5 、2=小程序 、0=未知 -->
              <a-select-option :value="0">未知</a-select-option>
              <a-select-option :value="1">H5</a-select-option>
              <a-select-option :value="2">小程序</a-select-option>
            </a-select>
          </div>

          <a-button
            class="screen-box"
            @click="searchButton('button')"
            :loading="search_button_loading"
            type="primary"
            icon="search"
            >搜索</a-button
          >

          <div class="screen-box">
            <a-dropdown-button @click="handleButtonClick">
              批量操作
              <a-menu slot="overlay" @click="handleMenuClick">
                <a-menu-item key="1">
                  <a-icon type="align-right" />重试</a-menu-item
                >
              </a-menu>
            </a-dropdown-button>
          </div>
        </div>
      </div>

      <div style="background-color: #fff; padding: 20px">
        <!-- 表头 -->
        <div class="table-th" :style="{ width: table_scroll_width + 'px' }">
          <div v-for="(item, index) in rableTitle" :key="index">
            <div class="table-th-cell" :style="{ width: item.width + 'px' }">
              {{ item.title }}
            </div>
          </div>
        </div>

        <!-- 表格内容 -->
        <div
          v-for="(item, index) in tableShowData"
          :key="index"
          class="table-td"
          :style="{ width: table_scroll_width + 'px' }"
        >
          <template v-for="(z_tem, z_ndex) in rableTitle">
            <div
              v-if="
                z_tem.type != 'cz' &&
                z_tem.type != 'remark' &&
                z_tem.type != 'type'
              "
              class="table-td-cell"
              :style="{ width: rableTitle[z_ndex].width + 'px' }"
            >
              {{ item[z_tem.type] }}
            </div>
            <div
              v-else-if="z_tem.type == 'type'"
              class="table-td-cell"
              :style="{ width: rableTitle[1].width + 'px' }"
            >
              {{ item.type | filterType }}
            </div>

            <!-- 备注 -->
            <div
              v-else-if="z_tem.type == 'remark'"
              class="table-td-cell"
              :style="{ width: rableTitle[6].width + 'px' }"
            >
              <div v-for="(item_z, index_z) in item.remark" :key="index_z">
                {{ item_z }}
              </div>
            </div>
            <!-- 操作 -->
            <div
              v-else-if="z_tem.type == 'cz'"
              class="table-td-cell"
              :style="{ width: rableTitle[z_ndex].width + 'px' }"
              style="display: flex; align-items: center"
            >
              <template v-if="item.status.indexOf('失败') > -1">
                <div @click="wxTdCz(1, item)" class="cz-cell">重试</div>

                <a-checkbox
                  :checked="item.checked"
                  @change="onChangeCheckbox($event, index)"
                >
                  <span style="font-size: 12px; color: #62a8ea">批量重试</span>
                </a-checkbox>
              </template>
            </div>
          </template>
        </div>

        <!-- 表格内容为空时显示 -->
        <div
          v-show="tableShowData.length == 0"
          style="text-align: center; text-align: center; padding: 80px 0 50px"
          :style="{ width: table_null_width + 'px' }"
        >
          <a-icon style="font-size: 70px; color: #999" type="file-search" />
          <div style="color: #999; font-size: 16px; margin-top: 20px">
            内容为空
          </div>
        </div>

        <!-- 分页 -->
        <pagingCompont
          :table_scroll_width="table_scroll_width"
          :table_null_width="table_null_width"
          :r_page="r_page"
          :r_limit="r_limit"
          :table_total="table_total"
          @pagination-Change="paginationChange"
        ></pagingCompont>
      </div>
    </div>

    <div v-show="show_page_type == 2">
      <copyDraftsSync ref="getCopyDraftsPage"></copyDraftsSync>
    </div>

    <!-- 批量重试 -->
    <a-modal
      :visible="retry_modal"
      title="批量重试"
      okType="primary"
      width="700px"
      okText="重试"
      cancelText="取消"
      @ok="retryOk"
      @cancel="retryCancel"
      :confirmLoading="retry_loading"
    >
      <div style="">
        <div style="margin-bottom: 10px">已选的重试项（模板名称）：</div>
        <div
          style="
            max-height: 360px;
            overflow-y: auto;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            cursor: default;
          "
        >
          <div
            v-for="(item, index) in selectedData"
            :key="index"
            style="
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              margin-right: 15px;
            "
            class=""
          >
            <div style="width: 80px; text-align: right">id：{{ item.id }}</div>
            <span style="margin: 0 5px"> — </span>
            <div style="width: 195px">{{ item.local_message_name }}</div>
          </div>
        </div>

        <!-- <div class="">id：4 —— 李永润</div> -->
      </div>
    </a-modal>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import copyDraftsSync from "@/views/Operate/operMessage/components/copyDraftsSync.vue";
import {
  pitcherLogList,
  gzhGroupTask,
  materialChannelSelect,
  wxMaterialSelect,
  gzhSyncRetry,
} from "@/request/api";
export default {
  name: "syncWxRecord_",
  components: {
    copyDraftsSync,
  },
  data() {
    this.dateFormat = "YYYY-MM-DD";
    return {
      locale,
      moment,
      startTime: "2022-06-12",
      endTime: "2022-06-23",

      // 表格部分内容
      // 表格的表头，规定宽度和要用的其他信息
      rableTitle: [
        { title: "模板名称", width: 130, type: "local_message_name" },
        { title: "模板类型", width: 130, type: "type" },
        { title: "公众号", width: 130, type: "gzh_name" },
        { title: "书城", width: 100, type: "channel_name" },
        { title: "同步时间", width: 150, type: "created_at" },
        { title: "同步状态", width: 120, type: "status" },
        { title: "备注", width: 250, type: "remark" },
        { title: "操作", width: 150, type: "cz" },
      ],
      tableShowData: [],
      table_scroll_width: 1000,
      table_null_width: 1000,

      search_button_loading: false,

      r_page: 1, // 页数
      r_limit: 20, // 每页多少条
      table_total: 0, // 表格内容总数

      r_status: undefined, // 状态
      r_channel_id: undefined, // 渠道
      r_gzh_id: undefined, // 公众号
      r_name: null, // 模板名字

      bookList: [], // 渠道下拉
      gzhSelect: [], // 公众号下拉

      selectedData: [], // 选择的内容

      retry_modal: false, // 重试
      retry_loading: false, // 重试

      tabData: [
        { label: "从本地图文模板创建", key: 1, status: true },
        { label: "从草稿箱/发表记录创建", key: 2, status: false },
      ],
      show_page_type: 1,
      r_type: undefined,
    };
  },
  mounted() {
    let that = this;
    that.search_button_loading = true;

    // 接收从计划页面传过来的参数
    if (this.$route.query) {
      if (this.$route.query.jump_type) {
        that.tabData.forEach((res) => {
          res.status = false;
        });

        that.$nextTick(() => {
          that.show_page_type = Number(this.$route.query.jump_type);
          that.tabData[that.show_page_type - 1].status = true;
        });
      }
    }

    // 获取表格信息
    let body_width = document.body.clientWidth - 60 - 50 - 190; // 筛选条件大盒子的宽度
    let nn = 0;
    that.rableTitle.forEach((res, index) => {
      nn = nn + res.width;
    });
    let table_width = 0;
    // 表格宽度小于屏幕的可视宽度减去两边的内边距，并且差距要在100px以上
    if (nn < body_width && body_width - nn > 50) {
      // 当表格内容不足以沾满一屏时，要适配成一屏
      // console.log("适配")
      that.rableTitle.forEach((res) => {
        // 针对表格每一项的宽度进行适配
        res.width = Math.round((res.width / nn) * body_width); // 这里减是为了避免res.width值的总和会超过body_width进行的微调，不-10问题应该也不大
      });
      table_width = body_width;
    } else {
      // 表格宽度大于等于屏幕可视宽度
      // console.log("不适配")
      table_width = nn;
    }
    that.table_scroll_width = table_width;
    that.table_null_width = table_width;

    // 获取7天前日期
    let date1 = new Date(new Date().getTime() - 604800000);
    let month1;
    if (date1.getMonth() + 1 < 10) {
      month1 = "0" + (date1.getMonth() + 1);
    } else {
      month1 = date1.getMonth() + 1;
    }
    let day1;
    if (date1.getDate() < 10) {
      day1 = "0" + date1.getDate();
    } else {
      day1 = date1.getDate();
    }
    that.startTime = date1.getFullYear() + "-" + month1 + "-" + day1;

    // 获取当前日期
    let date2 = new Date();
    let month2;
    if (date2.getMonth() + 1 < 10) {
      month2 = "0" + (date2.getMonth() + 1);
    } else {
      month2 = date2.getMonth() + 1;
    }
    let day2;
    if (date2.getDate() < 10) {
      day2 = "0" + date2.getDate();
    } else {
      day2 = date2.getDate();
    }
    that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;

    materialChannelSelect().then((res) => {
      console.log("下拉", res);
      that.selectData = res.data.data;
      let c_data = res.data.data.channel;
      let show_data = [];
      for (let key in c_data) {
        let ooo = {
          key,
          label: c_data[key],
          status: false,
        };
        show_data.push(ooo);
      }
      // show_data[0].status = true
      that.bookList = show_data;
      console.log("show_data", show_data);
    });

    // 修改母页面的tab高亮状态
    setTimeout(() => {
      that.$bus.$emit("tabPath", that.$route.fullPath);
    }, 300);

    that.searchButton();
  },
  methods: {
    // 日期选择
    onChangeDate(date, dateString) {
      // console.log(date, dateString);
      this.startTime = dateString[0];
      this.endTime = dateString[1];
    },
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 公众号
    handleChangeA(value) {
      console.log(value);
      this.r_gzh_id = value;
    },
    // 书城
    handleChangeB(e) {
      this.r_channel_id = e;
      this.search_button_loading = true;
      this.getGzhSelect(e);
    },
    // 状态
    handleChangeD(e) {
      this.r_status = e;
    },
    // 根据渠道获取公众号
    getGzhSelect(e) {
      let that = this;
      wxMaterialSelect({
        channel_id: e,
      }).then((res) => {
        that.search_button_loading = false;

        if (res.data.code == 401) {
          // 未登录
          localStorage.removeItem("access_token");
          that.$router.replace({ name: "login", params: { type: "not_log" } });
          return;
        }

        console.log("根据渠道获取公众号", res);
        that.gzhSelect = res.data.data.list;
      });
    },

    // 搜索
    searchButton(type) {
      let that = this;
      that.search_button_loading = true;

      if (type == "button") {
        that.r_page = 1;
      }

      let r_data = {
        start_date: that.startTime + " 00:00:00",
        end_date: that.endTime + " 23:59:59",
        page: that.r_page,
        limit: that.r_limit,
        status: that.r_status, // 状态
        channel_id: that.r_channel_id, // 书城
        gzh_id: that.r_gzh_id, // 公众号
        name: that.r_name,
        type: that.r_type,
      };

      gzhGroupTask(r_data).then((res) => {
        that.search_button_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("搜索成功");
          that.table_total = res.data.data.total;
          let data = res.data.data.data;
          data.forEach((res) => {
            res.checked = false;
          });
          that.tableShowData = res.data.data.data;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`其他错误：${res.data.msg}`);
          }
        }
      });
    },
    // 分页
    paginationChange(e) {
      let that = this;
      this.r_page = e;
      that.searchButton();
    },
    // 表格的操作
    wxTdCz(e, item) {
      let that = this;
      if (e == 1) {
        // 重试
        that.search_button_loading = true;
        let arr = [];
        arr.push(item.id);
        that.retryRequest(arr);
        // gzhSyncRetry({
        // 	ids: arr
        // }).then(res=>{
        // 	that.search_button_loading = false
        // 	console.log("重试",res)
        // 	if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
        // 		that.$message.success(res.data.msg || '重试成功');
        // 	}
        // 	else {
        // 		if(res.data.code == 401){ // 未登录
        // 			localStorage.removeItem("access_token");
        // 			that.$router.replace({name: 'login',params: {type:'not_log'}})
        // 		}
        // 		else {
        // 			that.$message.error(`错误：${res.data.msg}`);
        // 		}
        // 	}
        // })
      }
    },

    // 批量操作
    handleButtonClick(e) {
      console.log("click left button", e);
    },
    // 批量操作按钮点击
    handleMenuClick(e) {
      console.log("click", e);
      if (this.selectedData.length > 0) {
        let that = this;
        if (e.key == "1") {
          // 重试
          that.retry_modal = true;
        }
      } else {
        this.$message.warning("还没有选择内容");
      }
    },
    // 单选
    onChangeCheckbox(checkedList, index) {
      let that = this;
      if (that.tableShowData[index].checked) {
        // 为选中状态，然后要改为未选中状态
        that.tableShowData[index].checked = false;

        let iii;
        console.log(
          "that.tableShowData[index].id",
          that.tableShowData[index].id
        );
        that.selectedData.forEach((res, index_z) => {
          if (res.id == that.tableShowData[index].id) {
            iii = index_z;
          }
        });
        that.selectedData.splice(iii, 1);
        console.log("iii", iii);
      } else {
        // 未选中状态改为选中状态
        that.tableShowData[index].checked = true;
        if (that.selectedData.length === 0) {
          that.selectedData.push(that.tableShowData[index]);
        } else {
          // 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
          let ddd = true;
          for (let i = 0; i < that.selectedData.length; i++) {
            if (that.selectedData[i].id === that.tableShowData[index].id) {
              ddd = false;
              break;
            }
          }
          if (ddd) {
            that.selectedData.push(that.tableShowData[index]);
          }
        }
      }
      // that.tableShowData[index].checked = !that.tableShowData[index].checked
      console.log("that.selectedData", that.selectedData);
      let ccc = true;
      let iii = false;
      let nnn = that.selectedData.length || 0;
      console.log("that.selectedData.length", that.selectedData.length);
      that.tableShowData.forEach((res) => {
        if (res.checked) {
          iii = true;
          // nnn = nnn + 1
        }
        if (!res.checked) {
          ccc = false;
        }
      });
      // console.log("nnn",nnn)
      // if(ccc){
      // 	that.indeterminate = false
      // }
      // else {
      // 	that.indeterminate = iii
      // }
      // that.checkAll = ccc
    },
    retryRequest(ids) {
      let that = this;
      that.search_button_loading = true;

      gzhSyncRetry({
        ids,
      }).then((res) => {
        that.search_button_loading = false;
        console.log("重试", res);
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success(res.data.msg || "重试成功");
          that.searchButton();
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    retryOk() {
      let arr = [];
      this.selectedData.forEach((res) => {
        arr.push(res.id);
      });
      that.retryRequest(arr);
    },
    retryCancel() {
      this.retry_modal = false;
    },

    // tab切換
    tabChagen(e) {
      console.log(e);
      if (e.key == 1) {
        // 1草稿箱
        // 	this.r_page = 1
        // 	this.r_is_send = 0
      } else if (e.key == 2) {
        // 2发表记录
        // 	this.r_page = 1
        // 	this.r_is_send = 1
      }
      this.show_page_type = e.key; // 1草稿箱，2发表记录

      this.tabData.forEach((res) => {
        res.status = false;
      });
      e.status = true;

      // if(e.key == 1){
      // 	this.single_gzh = {}
      // }
      // this.searchButton('refresh')
    },
  },
  filters: {
    filterType(val) {
      // 1=H5、2=小程序、0=未知
      const map = {
        0: `未知`,
        1: `H5`,
        2: `小程序`,
      };
      return map[val] || "未知";
    },
  },
};
</script>

<style scoped>
/* 表格内的操作按钮 */
.cz-cell {
  color: #62a8ea;
  cursor: pointer;
  margin-right: 12px;
  /* margin-bottom: 5px; */
}
.cz-cell:hover {
  color: rgb(47, 136, 255);
}

.tab-box {
  /* width: 120px; */
  padding: 0 20px;
  height: 38px;
  line-height: 36px;
  text-align: center;
  background-color: #fff;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid transparent;
  user-select: none;
}
.tab-box-true {
  border: 1px solid #1d99ff;
  color: #1d99ff;
}
</style>
